import api from "../../../services/instanceapi";
import {tagCategoriesURL, tagCategoryURL} from "../../../services/api";
import {
    DELETE_TAG_CATEGORY, DELETE_TAG_CATEGORY_FAIL,
    FETCH_ALL_TAG_CATEGORIES,
    FETCH_ALL_TAG_CATEGORIES_FAIL,
    FETCH_TAG_CATEGORY,
    FETCH_TAG_CATEGORY_FAIL, LOADING_TAGS,
    PATCH_TAG_CATEGORY, PATCH_TAG_CATEGORY_FAIL,
    POST_TAG_CATEGORY,
    POST_TAG_CATEGORY_FAIL,
} from "../actionTypes";
import {checkErrorMessage} from "../../../utils/utils";
import {REQUEST_FAILED, REQUEST_SEND, SEND_MESSAGE_FAIL} from "../../message/actions/actionTypes";

export const postTagCategory = (data) => async (dispatch) => {
    try {
        const tag = await api.post(tagCategoriesURL(), data)
        dispatch({
            type: POST_TAG_CATEGORY,
            payload: {
                status: tag.status,
                message: tag.statusText
            }
        })
        dispatch({
            type: REQUEST_SEND,
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: POST_TAG_CATEGORY_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
            dispatch({
                type: REQUEST_FAILED,
            })
        }
        return Promise.reject(e)
    }
}


export const loadAllTagCategories = () => async (dispatch) => {
    try{
        dispatch({
            type: LOADING_TAGS,
        });
        const tagCategories = await api.get(tagCategoriesURL());
        dispatch({
            type: FETCH_ALL_TAG_CATEGORIES,
            payload: {
                tagCategories : tagCategories.data,
                status: tagCategories.status,
                message: tagCategories.statusText
            }
        })
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: FETCH_ALL_TAG_CATEGORIES_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
            dispatch({
                type: SEND_MESSAGE_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
        return Promise.reject(e)
    }
}

export const loadOneTagCategory = (id) => async (dispatch) => {
    try {
        const tagCategory = await api.get(tagCategoryURL(id))
        dispatch({
            type: FETCH_TAG_CATEGORY,
            payload: {
                id:tagCategory.data.id,
                name:tagCategory.data.name,
                color: tagCategory.data.color,
                tags:tagCategory.data.tags,
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: FETCH_TAG_CATEGORY_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
            dispatch({
                type: REQUEST_FAILED,
            })
        }
        return Promise.reject(e)
    }
}

export const patchTagCategory = (category_id, data) => async (dispatch) => {
    try {
        const category = await api.patch(tagCategoryURL(category_id), data)
        dispatch({
            type: PATCH_TAG_CATEGORY,
            payload: {
                status: category.status,
                message: category.statusText
            }
        })
        dispatch({
            type: REQUEST_SEND,
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: PATCH_TAG_CATEGORY_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
            dispatch({
                type: REQUEST_FAILED,
            })
        }
        return Promise.reject(e)
    }
}

export const deleteTagCategory = (category_id) => async (dispatch) => {
    try {
        const category = await api.delete(tagCategoryURL(category_id))
        dispatch({
            type: DELETE_TAG_CATEGORY,
            payload: {
                status: category.status,
                message: category.statusText
            }
        })
        dispatch({
            type: REQUEST_SEND,
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: DELETE_TAG_CATEGORY_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
            dispatch({
                type: REQUEST_FAILED,
            })
        }
        return Promise.reject(e)
    }
}



